import { render, staticRenderFns } from "./RefahBetaManager.vue?vue&type=template&id=2d91c200&scoped=true&"
import script from "./RefahBetaManager.vue?vue&type=script&lang=js&"
export * from "./RefahBetaManager.vue?vue&type=script&lang=js&"
import style0 from "./RefahBetaManager.vue?vue&type=style&index=0&id=2d91c200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d91c200",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAlert,VAvatar,VCard,VItem,VItemGroup,VProgressLinear})
